import { CheckCircleIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import Button from 'components/common/Button';
import { shortenAddress } from 'lib/utils';
import { getChainName } from 'lib/utils/chains';
import { Exploit } from 'lib/utils/exploits';
import useTranslation from 'next-translate/useTranslation';

interface Props {
  address: string;
  chainId: number;
  exploit: Exploit;
  status: 'affected' | 'safe';
}

const ExploitStatus = ({ address, chainId, exploit, status }: Props) => {
  const { t } = useTranslation();

  const chainName = getChainName(chainId);

  const icons = {
    affected: <ExclamationTriangleIcon className="h-12 w-12 text-red-500" />,
    safe: <CheckCircleIcon className="h-12 w-12 text-green-500" />,
  };

  const addressesForChainId = exploit.addresses.filter((address) => address.chainId === chainId);
  const spenderSearch = addressesForChainId.map(({ address }) => address).join(',');
  const baseHref = `/address/${address}?chainId=${chainId}`;
  const href = status === 'affected' ? `${baseHref}&spenderSearch=${spenderSearch}` : baseHref;

  return (
    <div className={'rounded-lg border border-black dark:border-white p-4'}>
      <div className="flex flex-col sm:flex-row items-center gap-4">
        <div className="flex items-center gap-4">
          <div className="shrink-0">{icons[status]}</div>
          <div className="flex flex-col gap-2 ml-2">
            <h3>{t(`exploits:subpages.result.${status}.title`)}</h3>
            <p className="text-sm">
              {t(`exploits:subpages.result.${status}.description`, {
                address: shortenAddress(address),
                chainName,
              })}
            </p>
          </div>
        </div>
        <Button className="shrink-0 w-full sm:w-fit" href={href} size="md" style="secondary" router>
          {t(`exploits:subpages.result.${status}.button`)}
        </Button>
      </div>
    </div>
  );
};

export default ExploitStatus;
